import React from "react"
import { Redirect } from "react-router-dom"
// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"

// Dashboard
import Dashboard from "../pages/Dashboard/index"

//Contacts
import Users from "pages/Users/Users"
import Roles from "pages/Roles/Index"
import Permissions from "pages/Permissions/Index"
import EndUsers from "pages/EndUsers/Index"
import Products from "pages/Settings/Products/Index"
import AccessExpiration from "pages/Settings/AccessExpiration/Index"
import OperatorProducts from "pages/Settings/OperatorProducts/Index"
import { CreateOperatorProduct } from "pages/Settings/OperatorProducts/Create"
import { EditOperatorProduct } from "pages/Settings/OperatorProducts/Edit"
import { CreateSupplier } from "pages/Settings/Suppliers/Create"
import AccessExpirationForm from "pages/Settings/AccessExpiration/AccessExpirationForm"
import Suppliers from "pages/Settings/Suppliers/Index"
import { EditSupplier } from "pages/Settings/Suppliers/Edit"
import index from "pages/RiskManagement/Parameters"
import AffiliateParameters from "pages/Affiliate/Parameters/Index"
import RiskPerUser from "pages/RiskPerUser/RiskPerUser"
import AgentsAccounts from "pages/Accounting/EndUserAccounts/Index"
import Deposits from "pages/Accounting/Deposits/Index"
import Withdrawals from "pages/Accounting/Withdrawals/Index"
import AffiliateWithdrawals from "pages/Accounting/AffiliateWithdrawals/Index"
import SportsTickets from "pages/Reports/SportsTickets/Index"
import GamesTickets from "pages/Reports/GamesTickets/Index"
import CashoutTickets from "pages/Reports/CashoutReport/Index"
import GameReport from "pages/Reports/GameReport/Index"
import CashierReport from "pages/Reports/CashierReport/Index"
import KironTickets from "pages/Reports/KironTickets/Index"
import ShopReport from "pages/Reports/ShopReport/Index"
import JackpotTickets from "pages/Reports/JackpotTickets/Index"
import CustomersReport from "pages/Reports/CustomersReport/Index"
import ReferralReport from "pages/Reports/RefferalReport/Index"
import AffiliateSummary from "pages/Reports/RefferalReport/AffilateSummary"
import BonusReport from "pages/Reports/BonusReport/Index"
import MimoReport from "pages/Reports/MimoReport/Index"
import TaxReport from "pages/Reports/TaxReport/Index"
import SuppliersReport from "pages/Reports/SuppliersReport/Index"
import GGRReport from "pages/Reports/GGRReport/Index"
import BoardReport from "pages/Reports/BoardReport/Index"
import SMSLogs from "pages/Reports/SMSLogs/Index"
import Promotions from "pages/Promotions/Promotions/Index"
import Acca7 from "pages/Promotions/Acca7/Index"
import { CreateAcca7 } from "pages/Promotions/Acca7/Create"
import { EditAcca7 } from "pages/Promotions/Acca7/Edit"
import MultiBetBonuses from "../pages/Reports/MultiBetBonusReport/Index"
import Acca7Report from "../pages/Reports/Acca7Report/Index"
import Bonuses from "pages/Promotions/Bonuses/Index"
import BonusTicketWinning from "../pages/Reports/BonusTicketWinningReport/Index"
import { CreateBonus } from "pages/Promotions/Bonuses/Create"
import { EditBonus } from "pages/Promotions/Bonuses/Edit"
import MultiBetBonus from "pages/Promotions/MultiBetBonus/Index"
import { CreateMultiBetBonus } from "pages/Promotions/MultiBetBonus/Create"
import { EditMultiBetBonus } from "pages/Promotions/MultiBetBonus/Edit"
import Comingsoon from "components/Common/ComingSoon"
import { CreateJackpot } from "pages/Promotions/Jackpots/Create"
import { EditJackpot } from "pages/Promotions/Jackpots/Edit"
import Jackpot from "pages/Promotions/Jackpots/Index"
import Marketing from "pages/CRM/Marketing/Index"
import Analytics from "pages/CRM/Analytics/Index"
import { CreatePromotion } from "pages/CRM/Marketing/Create"
import FormEditors from "../components/Common/FormEditors"
import StaticPages from "pages/CRM/StaticPages/Index"
import { CreateStaticPages } from "../pages/CRM/StaticPages/Create"
import { EditPromotion } from "../pages/CRM/Marketing/Edit"
import { EditStaticPages } from "../pages/CRM/StaticPages/Edit"
import Shops from "../pages/Admin/Shops/Index"
import { CreateShop } from "../pages/Admin/Shops/Create"
import { EditShop } from "../pages/Admin/Shops/Edit"
import Sports from "../pages/CRM/Content/Sports/Index.js"
import Locations from "../pages/CRM/Content/Locations/Index.js"
import Leagues from "../pages/CRM/Content/Leagues/Index.js"
import SpecialMarkets from "../pages/CRM/Content/SpecialMarkets/Index.js"
import Campaigns from "../pages/CRM/Content/Campaigns/index"
import { CreateCampaigns } from "./../pages/CRM/Content/Campaigns/Create"
import { EditCampaigns } from "./../pages/CRM/Content/Campaigns/Edit"
import Cashiers from "../pages/Admin/Cashier/Index"
import { CreateCashier } from "../pages/Admin/Cashier/Create"
import { EditCashier } from "../pages/Admin/Cashier/Edit"
import Content from "../pages/CRM/Content/Banners/Index"
import { CreateBanner } from "../pages/CRM/Content/Banners/Create"
import { EditBanner } from "../pages/CRM/Content/Banners/Edit"
import { ViewJackpot } from "../pages/Promotions/Jackpots/View"
import JackpotTicketsBet from "../pages/Reports/JackpotTickets/JackpotTicketsBet"
import Freebets from "../pages/Promotions/Freebets/Index"
import { CreateFreebets } from "../pages/Promotions/Freebets/Create"

import Welcome from "../pages/Dashboard/Welcome"
import CashierAccounts from "../pages/Accounting/CashierAccounts"
import ViewFreeSpin from "pages/Promotions/Freebets/View"
import AutometedFreespin from "../pages/Promotions/AutometedFreespin/Index"
import { CreateAutoFreebets } from "pages/Promotions/AutometedFreespin/Create"
import ViewAutoFreeSpin from "pages/Promotions/AutometedFreespin/View"
import RafReport from "../pages/Reports/RafReport/Index"
import AffiliateBonuses from "../pages/Promotions/AffiliateBonuses/Index"
import { CreateAffiliateBonus } from "../pages/Promotions/AffiliateBonuses/Create"
import ViewAffiliateBonus from "../pages/Promotions/AffiliateBonuses/View"
import BookABetTickets from "../pages/Reports/BookABetTickets/Index"
import BookABetReport from "../pages/Reports/BookABetReport/Index"
import JackpotReport from "../pages/Reports/JackpotReport/Index"
import KYC from "../pages/KYC/Index"

const authProtectedRoutes = [
  { path: "/welcome", component: Welcome },
  { path: "/dashboard", component: Dashboard },
  { path: "/roles", component: Roles },
  { path: "/permissions", component: Permissions },
  { path: "/admin/users", component: Users },
  { path: "/end-users", component: EndUsers },
  { path: "/products", component: Products },
  { path: "/access-expiration", component: AccessExpiration },
  { path: "/operator-products", component: OperatorProducts },
  { path: "/operator-products/create", component: CreateOperatorProduct },
  {
    path: `/operator-products/edit`,
    component: EditOperatorProduct,
  },
  {
    path: `/supplier-commissions`,
    component: Suppliers,
  },
  { path: "/supplier/create", component: CreateSupplier },
  {
    path: `/supplier-commissions/edit`,
    component: EditSupplier,
  },
  {
    path: `/set-access-expiration`,
    component: AccessExpirationForm,
  },
  {
    path: `/parameters`,
    component: index,
  },
  {
    path: `/affiliate`,
    // eslint-disable-next-line react/display-name
    component: () => <Redirect to="/affiliate/dashboard" />,
  },
  {
    path: `/affiliate/parameters`,
    component: AffiliateParameters,
  },
  {
    path: `/risk-per-user`,
    component: RiskPerUser,
  },
  {
    path: `/KYC`,
    component: KYC,
  },
  {
    path: `/end-user-accounts`,
    component: AgentsAccounts,
  },
  {
    path: `/cashier-accounts`,
    component: CashierAccounts,
  },
  {
    path: `/deposits`,
    component: Deposits,
  },
  {
    path: `/withdrawals`,
    component: Withdrawals,
  },
  {
    path: `/affiliate/withdrawal-report`,
    component: AffiliateWithdrawals,
  },
  {
    path: `/reports/sports-tickets`,
    component: SportsTickets,
  },
  {
    path: `/reports/cashout-tickets`,
    component: CashoutTickets,
  },

  {
    path: `/reports/book-a-bet-tickets`,
    component: BookABetTickets,
  },
  { path: "/form-editors", component: FormEditors },

  {
    path: `/reports/games-tickets`,
    component: GamesTickets,
  },
  {
    path: `/reports/games-reports`,
    component: GameReport,
  },
  {
    path: `/reports/book-a-bet-reports`,
    component: BookABetReport,
  },
  {
    path: `/reports/cashier-reports`,
    component: CashierReport,
  },
  {
    path: `/reports/shop-reports`,
    component: ShopReport,
  },
  {
    path: `/reports/kiron-tickets`,
    component: KironTickets,
  },
  {
    path: `/reports/jackpot-tickets`,
    component: JackpotTickets,
  },
  {
    path: `/reports/jackpot-report`,
    component: JackpotReport,
  },
  {
    path: `/reports/jackpot-tickets/jackpot-bet/:id`,
    component: JackpotTicketsBet,
  },
  {
    path: `/reports/customers-report`,
    component: CustomersReport,
  },
  {
    path: `/affiliate/dashboard`,
    component: ReferralReport,
  },

  {
    path: `/affiliate/dashboard/:id/summary`,
    component: AffiliateSummary,
  },
  {
    path: `/reports/bonus-report`,
    component: BonusReport,
  },
  {
    path: `/reports/multibet-bonus-report`,
    component: MultiBetBonuses,
  },
  {
    path: `/reports/acca7-report`,
    component: Acca7Report,
  },
  {
    path: `/reports/mimo-report`,
    component: MimoReport,
  },
  {
    path: `/reports/tax-report`,
    component: TaxReport,
  },
  {
    path: `/reports/suppliers-report`,
    component: SuppliersReport,
  },
  {
    path: `/reports/board-report`,
    component: BoardReport,
  },
  {
    path: `/reports/GGR-report`,
    component: GGRReport,
  },
  {
    path: `/reports/raf-report`,
    component: RafReport,
  },
  {
    path: `/reports/sms-logs`,
    component: SMSLogs,
  },
  {
    path: `/reports/bonus-ticket-winning-Report`,
    component: BonusTicketWinning,
  },
  {
    path: `/promotions`,
    component: Promotions,
  },
  {
    path: `/promotions/bonuses`,
    component: Bonuses,
  },
  {
    path: `/promotions/bonus/create`,
    component: CreateBonus,
  },
  {
    path: `/promotions/bonuses/edit`,
    component: EditBonus,
  },
  {
    path: `/affiliate/bonus-configuration/create`,
    component: CreateAffiliateBonus,
  },
  {
    path: `/affiliate/bonus-configuration/edit`,
    component: CreateAffiliateBonus,
  },
  {
    path: `/affiliate/bonus-configuration/view`,
    component: ViewAffiliateBonus,
  },
  {
    path: `/affiliate/bonus-configuration`,
    component: AffiliateBonuses,
  },
  {
    path: `/promotions/acca7`,
    component: Acca7,
  },
  {
    path: `/promotions/acca7/create`,
    component: CreateAcca7,
  },
  {
    path: `/promotions/acca7/edit`,
    component: EditAcca7,
  },
  {
    path: `/promotions/multibet-bonus`,
    component: MultiBetBonus,
  },
  {
    path: `/promotions/multibet-bonus/create`,
    component: CreateMultiBetBonus,
  },
  {
    path: `/promotions/multibet-bonus/edit`,
    component: EditMultiBetBonus,
  },
  {
    path: `/crm/marketing`,
    component: Marketing,
  },
  {
    path: `/crm/marketing/create`,
    component: CreatePromotion,
  },
  {
    path: `/crm/marketing/edit`,
    component: EditPromotion,
  },
  {
    path: `/crm/analytics`,
    component: Analytics,
  },
  {
    path: `/admin/shops`,
    component: Shops,
  },
  {
    path: `/admin/shops/create`,
    component: CreateShop,
  },
  {
    path: `/admin/shops/edit`,
    component: EditShop,
  },
  {
    path: `/admin/shops`,
    component: EditPromotion,
  },
  {
    path: `/admin/cashiers`,
    component: Cashiers,
  },
  {
    path: `/admin/cashier/create`,
    component: CreateCashier,
  },
  {
    path: `/admin/cashiers/edit`,
    component: EditCashier,
  },
  {
    path: `/crm/static-pages`,
    component: StaticPages,
  },
  {
    path: `/crm/static-pages/create`,
    component: CreateStaticPages,
  },
  {
    path: `/crm/static-pages/edit`,
    component: EditStaticPages,
  },
  {
    path: `/promotions/jackpots`,
    component: Jackpot,
  },
  {
    path: `/promotions/jackpots/create`,
    component: CreateJackpot,
  },
  {
    path: `/promotions/jackpots/edit`,
    component: EditJackpot,
  },
  {
    path: `/promotions/jackpots/view`,
    component: ViewJackpot,
  },
  {
    path: `/crm/content/coming-soon`,
    component: Comingsoon,
  },
  {
    path: `/crm/content/sports`,
    component: Sports,
  },
  {
    path: `/crm/content/locations`,
    component: Locations,
  },
  {
    path: `/crm/content/leagues`,
    component: Leagues,
  },
  {
    path: `/crm/content/special-markets`,
    component: SpecialMarkets,
  },
  {
    path: `/crm/content/campaigns`,
    component: Campaigns,
  },
  {
    path: `/crm/content/campaigns/create`,
    component: CreateCampaigns,
  },
  {
    path: `/crm/content/campaigns/edit`,
    component: EditCampaigns,
  },
  {
    path: `/crm/content`,
    component: Content,
  },
  {
    path: `/crm/content/create`,
    component: CreateBanner,
  },
  {
    path: `/crm/content/edit`,
    component: EditBanner,
  },
  {
    path: `/promotions/Freespin`,
    component: Freebets,
  },
  {
    path: `/promotions/Freebets/create`,
    component: CreateFreebets,
  },
  {
    path: `/promotions/Freebets/:id`,
    component: ViewFreeSpin,
  },
  {
    path: `/promotions/AutometedFreeSpin`,
    component: AutometedFreespin,
  },
  {
    path: `/promotions/AutometedFreeSpin/create`,
    component: CreateAutoFreebets,
  },
  {
    path: `/promotions/AutometedFreeSpin/:id`,
    component: ViewAutoFreeSpin,
  },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/welcome" /> },
]

const publicRoutes = [{ path: "/login", component: Login }]

export { authProtectedRoutes, publicRoutes }
